import React, { memo } from 'react';
import { createUseStyles, useTheme, Text, Progress, Icon } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'ProgressContent');

const ProgressContent = ({
    current,
    total = 100,
    description,
    subDescription,
    withRemaining = true,
}) => {
    const { t } = useWeb5Context();
    const classes = useStyles();
    const theme = useTheme();
    const percent = current && total ? ((current / total) * 100).toFixed() : 0;

    return (
        <div className={classes.root}>
            {description && <Text>{description}</Text>}
            {subDescription && <Text>{subDescription}</Text>}
            <div className={classes.contentBox}>
                <div className={classes.contentBoxText}>
                    <Icon
                        className={classes.contentBoxIcon}
                        color={theme.colors.primary.black}
                        name="sync"
                    />
                    <Text bold>{t('label_bulk_loading_complete', [percent])}</Text>
                </div>

                <Progress className={classes.contentBoxBar} value={percent} />

                {withRemaining && (
                    <Text type="caption">{t('label_bulk_remaining', [total - current])}</Text>
                )}
            </div>
        </div>
    );
};

export default memo(ProgressContent);
